import { differenceInMonths, isAfter } from 'date-fns';
import { useMemo } from 'react';
import {
  useLandHistories,
  useLandHistoryLastVisitedDate,
} from '~/components/Land/History/LandHistory.hooks';
import { sharedDateTimer } from '~/components/Util/timer.hooks';

export const useHasNewLandHistory = () => {
  const { data: landHistories } = useLandHistories({ category: 'ALL' });
  const { value: lastVisit } = useLandHistoryLastVisitedDate();

  return useMemo(
    () =>
      landHistories?.pages[0]?.histories.some((each) => {
        if (differenceInMonths(sharedDateTimer.now, each.updatedAt) > 0) return false;
        return isAfter(each.updatedAt, lastVisit);
      }),
    [landHistories?.pages, lastVisit]
  );
};
